import { VisitorActionTypes } from './visitor.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    visitorAddRecordSuccess: null,
    visitorAddRecordError: null,
    visitorAddRecordReqStatus: '',
    visitorListSuccess: null,
    visitorListError: null,
    visitorExitSuccess: null,
    visitorExitError: null,
    visitorExitReqStatus: '',
    visitorUpdateConfigurationSuccess: null,
    visitorUpdateConfigurationError: null,
    visitorUpdateConfigurationReqStatus: '',
    visitorGetConfigurationSuccess: null,
    visitorGetConfigurationError: null
}

const visitorReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VisitorActionTypes.VISITOR_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                visitorListSuccess: action.payload,
                visitorListError: null
            }
        case VisitorActionTypes.VISITOR_LIST_REQUEST_ERROR:
            return {
                ...state,
                visitorListSuccess: null,
                visitorListError: action.payload
            }
        case VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST_SUCCESS:
            return {
                ...state,
                visitorAddRecordSuccess: action.payload,
                visitorAddRecordError: null,
                visitorAddRecordReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST_ERROR:
            return {
                ...state,
                visitorAddRecordSuccess: null,
                visitorAddRecordError: action.payload,
                visitorAddRecordReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST_STATUS:
            return {
                ...state,
                visitorAddRecordReqStatus: ''
            }
        case VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST_SUCCESS:
            return {
                ...state,
                visitorExitSuccess: action.payload,
                visitorExitError: null,
                visitorExitReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST_ERROR:
            return {
                ...state,
                visitorExitSuccess: null,
                visitorExitError: action.payload,
                visitorExitReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST_STATUS:
            return {
                ...state,
                visitorExitReqStatus: ''
            }
        case VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST_SUCCESS:
            return {
                ...state,
                visitorUpdateConfigurationSuccess: action.payload,
                visitorUpdateConfigurationError: null,
                visitorUpdateConfigurationReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST_ERROR:
            return {
                ...state,
                visitorUpdateConfigurationSuccess: null,
                visitorUpdateConfigurationError: action.payload,
                visitorUpdateConfigurationReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST_STATUS:
            return {
                ...state,
                visitorUpdateConfigurationReqStatus: ''
            }
        case VisitorActionTypes.VISITOR_GET_CONFIGURATION_REQUEST_SUCCESS:
            return {
                ...state,
                visitorGetConfigurationSuccess: action.payload,
                visitorGetConfigurationError: null
            }
        case VisitorActionTypes.VISITOR_GET_CONFIGURATION_REQUEST_ERROR:
            return {
                ...state,
                visitorGetConfigurationSuccess: null,
                visitorGetConfigurationError: action.payload
            }
        case VisitorActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default visitorReducer